import { render, staticRenderFns } from "./socu-approve.vue?vue&type=template&id=3eace937&"
import script from "./socu-approve.vue?vue&type=script&lang=js&"
export * from "./socu-approve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eace937')) {
      api.createRecord('3eace937', component.options)
    } else {
      api.reload('3eace937', component.options)
    }
    module.hot.accept("./socu-approve.vue?vue&type=template&id=3eace937&", function () {
      api.rerender('3eace937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/socu-approve.vue"
export default component.exports